import request from '../request';

export default {
  //素材-列表
  lists(data) {
    return request.get('/material/lists', data);
  },

  //素材-添加
  add(data) {
    return request.post('/material/add', data);
  },

  //素材-删除
  delete(data) {
    return request.post('/material/delete', data);
  },

  //素材-更新
  update(data) {
    return request.post('/material/update', data);
  },

  //vr素材-列表
  convertList(data) {
    return request.post('/material/convertList', data);
  },

  //vr素材-上传vr至素材库
  addMaterial(data) {
    return request.post('/material/addMaterial', data);
  },
	
	//根据materialId 获取groupId
	getMaterialInfo(data) {
		return request.get('/material/getMaterialInfo', data);
	},


};
